import { ReplicaType } from "types";
import Version2 from "./v2";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp6-family-savaged-in-latest-death-eater-attack",
  name: `The Daily Prophet\n'Family Savaged in Latest Death Eater Attack'`,
  nameFormatted: {
    primary: "The Daily Prophet",
    secondary: "'Family Savaged in Latest Death Eater Attack'",
  },
  origin: "Harry Potter and the Half-Blood Prince",

  category: replicaCategories.harryPotter,

  versions: [Version2],
};

export default data;
